<template>
  <div id="overview" class="animated fadeIn pb4">
    <!-- desktop view -->
    <div v-if="!showMobile">
      <div id="bannerbody" class="gibson p3 center relative flex justify-center items-start">
        <!-- <div class="lg-col-7 hide">
          <div class="mb4"></div>
          <h1 class="white regular mb3" style="font-size: 7.5rem;">VELKOMMEN TIL</h1>
          <div class="flex mb4">
            <div class="col-3 p0">
              <img src="/static/svg/h.svg" width="85%" class="mb1">
              <div>
                <img src="/static/svg/star-dark.svg" width="13%" class="mr1">
                <img src="/static/svg/star-dark.svg" width="13%" class="mr1">
                <img src="/static/svg/star-dark.svg" width="13%" class="mr1">
                <img src="/static/svg/star-dark.svg" width="13%" class="mr1">
                <img src="/static/svg/star-dark.svg" width="13%" class="mr1">
              </div>
            </div>
            <div class="col-9 p0">
              <h2 class="white regular" style="font-size: 6rem;"><span>Håndværker.dk</span>
              <span style="font-size: 8.1rem;">Prisen <span class="green">2021</span></span></h2>
            </div>
          </div>
          <h1 class="white regular mb4" style="font-size: 7.5rem;">WEBSHOPPEN</h1>
          <div class="pt2 hide">
            <a href="#/webshop/products" class="action-button py1 px3 m0 line-height-1 gibson not-rounded border-none center">
              <span class="mr2 regular">KØB NU</span><span><i class="el-icon-right"></i></span>
            </a>
          </div>
        </div> -->
      </div>
      <div class="clearfix" v-if="loading">
        <div class="col-12">
          <div class="loader"></div>
        </div>
      </div>
      <div class="py2 flex flex-wrap" v-else>
        
        <!-- Ads product -->
        <div v-for="(cat,index) in catData" :key="index" :id="cat.ID" class="lg-col-6 md-col-12 p0" >
          <div class="block" >
            <div class="flex more-muted-background p3 mr3 mb3" >
              <div class="col-6">
                <div :class="'clearfix loader-'+cat.ID" v-if="imageLoadingpng">
                  <div class="col-12">
                    <div class="loader"></div>
                    <p class="center mediumgrey bold">Genererer forhåndsvisning...</p>
                  </div>
                </div>
                <div :class="'hide catImages-'+cat.ID">
                  <!-- Regular cat -->
                  <a :href="'#/webshop/products?cat_id='+cat.ID" :title="cat.VALUE" >
                    <img :src="cat.IMAGE_URL" width="100%" class="prod-img" @load="onImageLoad(cat.ID)" >
                    <!-- <img :src="'http://widget.haandvaerker.dk/prisen/winnersBadge/streamer/rendered/'+haaId+'/1.jpg'" width="100%" :class="'prod-img catId-'+cat.ID" rel="preload" @load="onImageLoad(cat.ID)" @error="setImage(cat.ID, 'streamer/streamerPng')" v-else> -->
                  </a>
                </div>
              </div>
              <div class="col-6 center ">
                <span class="h5 darkblue bold">{{cat.VALUE}}</span>
                <div class="pb3"></div>
                <div>
                  <!-- Regular cat -->
                  <a :href="'#/webshop/products?cat_id='+cat.ID" class="regular caps action-button btn-secondary py1 px3 m0 line-height-1 gibson not-rounded border-none inline-block">
                    <span>Bestil {{cat.VALUE}}</span>
                  </a>
                </div>
                <div class="pb3 "></div>
                  <p class="darkblue gibson semi-bold m0">
                    {{cat.DESCRIPTION}}
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- mobile view -->
    <div v-if="showMobile" class="mobile-view">
      <div id="bannerbody" class="gibson p3 fourthcolor-background center relative flex items-start">
        <div class="col-12 hide">
          <h1 class="white regular mb3" style="font-size: 3.3rem;">VELKOMMEN TIL</h1>
          <div class="flex mb3">
            <div class="col-3 p0">
              <img src="/static/svg/h.svg" width="85%" class="mb1">
              <div>
                <img src="/static/svg/star-dark.svg" width="15%" class="mr0">
                <img src="/static/svg/star-dark.svg" width="15%" class="mr0">
                <img src="/static/svg/star-dark.svg" width="15%" class="mr0">
                <img src="/static/svg/star-dark.svg" width="15%" class="mr0">
                <img src="/static/svg/star-dark.svg" width="15%" class="mr0">
              </div>
            </div>
            <div class="col-9 p0">
              <h2 class="white regular" style="font-size: 2.7rem;"><span>Håndværker.dk</span>
              <span style="font-size: 3.6rem;">Prisen <span class="green">2021</span></span></h2>
            </div>
          </div>
          <h1 class="white regular mb4" style="font-size: 3.6rem;">WEBSHOPPEN</h1>
          <div class="pt2 hide">
            <a href="#/webshop/products" class="action-button p2 line-height-1 gibson not-rounded border-none block">
            <span class="mr2 regular">KØB NU</span><span><i class="el-icon-right"></i></span>
            </a>
          </div>
        </div>
      </div>
      <div class="clearfix" v-if="loading">
        <div class="col-12">
          <div class="loader"></div>
        </div>
      </div>
      <div class="lightgrey-background p3" v-else>
        <!-- Ads product -->
        <div v-for="(cat,index) in catData" :key="index" >
          <div class="col-12 p0">
            <div class="white-background p2 mb3 cstm-height">
              <div class="flex flex-wrap items-center mb3">
                <div class="col-6 pr2 p0">
                  <!-- Din digitale pakke cat loader -->
                  <div :class="'clearfix loader-'+cat.ID">
                    <div class="col-12" >
                      <div class="loader"></div>
                    </div>
                  </div>
                  <div :class="'hide catImages-'+cat.ID">
                    <!-- Regular cat -->
                    <a :href="'#/webshop/products?cat_id='+cat.ID" :title="cat.VALUE" >
                      <img :src="cat.IMAGE_URL" width="100%" class="prod-img" @load="onImageLoad(cat.ID)" >
                      <!-- <img :src="'http://widget.haandvaerker.dk/prisen/winnersBadge/bladder/rendered/'+haaId+'/1.jpg'" width="100%" :class="'prod-img catId-'+cat.ID" rel="preload" @load="onImageLoad(cat.ID)" @error="setImage(cat.ID, 'bladder/bladderPng')" v-else> -->
                    </a>
                    <!-- Din digitale pakke cat -->
                    <!-- <a href="#/badges" :title="cat.VALUE" v-else>
                      <img :src="'http://widget.haandvaerker.dk/prisen/winnersBadge/mail/rendered/'+haaId+'/1.jpg'" width="100%" :class="'prod-img catId-'+cat.ID" rel="preload" @load="onImageLoad(cat.ID)" @error="setImage(cat.ID, 'mail/mailSignaturePng')">
                    </a> -->
                  </div>
                </div>
                <div class="col-6 center p0">
                  <span class="h5 darkblue bold">{{cat.VALUE}}</span>
                  <p class="font-weight-light gibson line-height-2 m0">
                    {{cat.DESCRIPTION}}
                  </p>
                </div>
              </div>
              <div class="col-12 p0">
                <div class="center">
                  <!-- Regular cat -->
                  <a :href="'#/webshop/products?cat_id='+cat.ID" class="h6 caps action-button pt2 pb1 px2 gibson not-rounded border-none block" v-if="cat.ID != 204">
                    <!-- Supplér Blærerøvskit cat -->
                    <!-- <span v-if="cat.ID == 205">Bestil streamers</span> -->
                    <!-- Regular cat -->
                    <span >KØB {{cat.VALUE}}</span>
                  </a>
                  <!-- Digitale cat -->
                  <a href="#/badges" class="h4 caps action-button pt2 pb1 px2 gibson not-rounded border-none block" v-else>
                    <span>Hent her</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <WebshopFooter v-if="!loading">
    </WebshopFooter>
  </div>
</template>

<script>
import WebshopFooter from './footer'
import Createbannerwebshop from './Createbannerwebshop'
export default {
  name: '',
  components: {
    WebshopFooter,
    Createbannerwebshop
  },
  data () {
    return {
      loading: true,
      imageLoadingpng: true,
      catData: [],
      initcatData: [],
      salesPerson: '',
      showbadge: localStorage.getItem('showbadgewebshop'),
      haaId: localStorage.getItem('haaid')
      // bannerimageurl: 'https://widget.haandvaerker.dk/banners/images/overviewbanner/overviewbannerPng.php?id=' + localStorage.getItem('haaid'),
      // bannerimageurl2: 'http://widget.haandvaerker.dk/banners/images/overviewbanner/rendered/' + localStorage.getItem('haaid') + '.jpg' !== 'undefined' && 'http://widget.haandvaerker.dk/banners/images/overviewbanner/' + localStorage.getItem('haaid') + '.jpg' !== null ? 'http://widget.haandvaerker.dk/banners/images/overviewbanner/rendered/' + localStorage.getItem('haaid') + '.jpg' : 'http://widget.haandvaerker.dk/banners/images/overviewbanner/productpng.php?id=' + localStorage.getItem('haaid') + '.jpg'
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.salesPerson = localStorage.getItem('id_token_portalbitrix')
    this.reloadcategory()
    this.haaId = localStorage.getItem('haaid')
  },
  methods: {
    reloadcategory () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/webshop/GetCategory/0', data, { headers }, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            var catReses = []
            if (res.success) {
              var catRes = response.data.data
              if (this.showbadge === 'no') {
                catReses = catRes.filter(function (a) {
                  return a.ID !== 205
                })
              } else {
                catReses = catRes
              }
              catReses.forEach(element => {
                this.getproducteach(element)
              })
              this.loading = false
            } else {
              this.loading = false
              console.log('Error in reloadcategory()')
            }
          },
          response => {
            console.log('error in loading all category, Bai Rodel was here')
          }
        )
    },
    getproducteach (catResess) {
      // getting prod from this cat
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
        // operation: 'bitrixApi',
        // salesPerson: this.salesPerson,
        // type: 'GET',
        // url: 'webshop/GetProducts/0/0/' + catResess.ID
      }
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/webshop/GetProducts/0/0/' + catResess.ID, data, { headers }, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var dataRes = response.data.data[0]
            if (dataRes.CATEGORY_ID !== 205) {
              catResess['IMAGE_URL'] = 'http://widget.haandvaerker.dk/products/' + dataRes.PRODUCT_GROUP + '/' + dataRes.SIZE + '/rendered/' + this.haaId + '.jpg'
            } else {
              catResess['IMAGE_URL'] = 'https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/rendered/36910/3.jpg'
            }
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
      // end of  getting prod from this cat   delete this if the product list is done
      this.catData.push(catResess)
    },
    addcategory () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      console.log('this.salesPerson', this.salesPerson)
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
        CategoryId: '301',
        Description: 'Skal du have synlighed, når du arbejder på byggepladsen? Sæt et Byggepladsskilt op.',
        ImageUrL: '/upload/iblock/7ea/8be5g2o3ku93vqt0426n21zmohqp4w97/Sample 1-01.png'
      }
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/webshop/SaveCategoryCustomFields', data, { headers }, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            console.log('getcategory', res)
            if (res.success) {
              console.log('addresult', res)
            } else {
              console.log('Error in saving category')
            }
          },
          response => {
            console.log('error in loading all category')
          }
        )
    },
    displayCategories () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetCategory/0'
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          console.log('prisen', res)
          // if (res.success) {
          //   var catRes = response.data.data
          //   this.catData = catRes
          //   this.loading = false
          // } else {
          //   this.loading = false
          //   console.log('Error in displayCategories()')
          // }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    onImageLoad (catID) {
      var hidden = document.querySelector('.catImages-' + catID)
      hidden.classList.remove('hide')
      var loader = document.querySelector('.loader-' + catID)
      loader.remove()
    },
    setImage (catID, filePath) {
      this.imageLoadingpng = false
      var img = document.querySelector('.catId-' + catID)
      img.src = 'https://widget.haandvaerker.dk/prisen/winnersBadge/' + filePath + '.php?id=' + this.haaId
    }
  }
}
</script>
<style>
  #bannerbody .fontnew {
    font-size: 2vw;
  }  
  #bannerbody .fontnewsmall {
    font-size: 1vw;
  }
  #overview a:hover:after {
    display: none;
  }
  #overview a.termsconditions:hover {
    color: #19a3c0;
  }
  #overview .prod-img {
    height: 210px;
    object-fit: contain;
  }
  #overview .lg-col-6.p0:nth-child(even) > div > div {
    margin-right: 0;
  }
  #overview .fourthcolor-background::before {
    content: "1";
    color: transparent;
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    background-position: 100% 80%;
    background-size: cover;
  }
  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @media (max-width: 64em) {
    #overview .flex.mr3 {
        margin-right: 0;
    }
    #overview .prod-img {
      height: auto;
    }
    #overview .fourthcolor-background::before {
      background-position: center;
    }
    #overview .lightgreen-background.btn-secondary:hover {
      background: #19a3c0;
      border: 1px solid #19a3c0;
    }
    #bannerbody {
      height: 315px;
      background-size: cover;
    }
  }
</style>


// WEBPACK FOOTER //
// overview.vue?87078750